import { createSelector } from 'reselect';
import { carouselOnPLPSelector } from 'selectors/testTarget/offers/carouselOnPLP/carouselOnPLPSelector';

const enabledSelector = createSelector(carouselOnPLPSelector, carouselOnPLP => carouselOnPLP.enabled);

export { enabledSelector };
